import it from '@/internationalization/trans/chefs/it/it.json';
export default {
  trans: it,
};
